import { mapState, mapGetters } from 'vuex';
import Contextmenu from '../../chart/Contextmenu.vue';

export default {
  components: {
    Contextmenu,
  },
  data() {
    return {
      contextmenuParam: {
        show: false,
        x: 0,
        y: 0,
        items: [],
      },
    };
  },
  computed: {
    ...mapState('common/menu', ['realtime']),
    ...mapGetters('common/system', ['getSystemById']),
    menus() {
      const system = this.getSystemById(this.instance.systemId);
      const [{ children: realtimeMenus }] = this.realtime;
      const [{ children: menus }] = realtimeMenus.filter(m => m.name == system.stackType.toLowerCase());
      return menus;
    },
  },
  methods: {
    // BEGIN::Added.by.KWShin.2024.01.14.
    // Vue bind를 이용하여 event handler를 등록하지 않고
    // Javascript native 방식으로 event handler를 등록한 경우에 사용할 함수.
    // 패러미터로 event가 넘어오는 것이 아니라 echarts의 params가 넘어온다.
    onContextmenuChartNative(params) {
      // console.log('in overview/whole/abap/mixins/contextmenuable.js, onContextmenuChartNative(), params', params);
      this.onContextmenuChart(params.event.event);
    },
    // FINISH::Added.by.KWShin.2024.01.14.
    onContextmenuChart(event) {
      event.preventDefault();
      const menu = this.menus.find(menu => menu.url == this.contextmenuUrl);
      if (!menu) return;
      const descendantQuery = this.contextLinkType === 'system' ? '' : `?d=${this.instance.id}`;
      this.contextmenuParam = {
        show: true,
        x: event.clientX,
        y: event.clientY,
        items: [
          {
            icon: menu.icon,
            text: this.$t(menu.messageCode),
            handler: () => window.open(`${menu.url}/${this.instance.systemId}${descendantQuery}`, '_blank'),
          },
        ],
      };
    },
  },
};
